import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ACTION_MENU_LIST_WRAPPER_CLASS_NAME = 'ActionMenuListWrapper';
export const ACTION_MENU_LIST_WRAPPER_CLASS_SLOTS: Array<
	keyof ActionMenuListWrapperClasses
> = ['root', 'content', 'popover'] as const;

export type ActionMenuListWrapperClassSlot =
	(typeof ACTION_MENU_LIST_WRAPPER_CLASS_SLOTS)[number];

export interface ActionMenuListWrapperClasses {
	root: string;
	content: string;
	popover: string;
}

export type ActionMenuListWrapperClassKey = keyof ActionMenuListWrapperClasses;

export const getActionMenuListWrapperUtilityClass = (slot: string) =>
	generateUtilityClass(
		ACTION_MENU_LIST_WRAPPER_CLASS_NAME,
		slot as ActionMenuListWrapperClassSlot,
	);

export const actionMenuListWrapperClasses: ActionMenuListWrapperClasses =
	generateUtilityClasses(ACTION_MENU_LIST_WRAPPER_CLASS_NAME, [
		'root',
		'content',
		'popover',
	]);

export default actionMenuListWrapperClasses;
